import React from 'react';
const quotes = ['"I\'m looking for my first home."', '"Can we keep the payment under $2,400?"', '"What did I promise on the last call?"', '"My base is ninety-six, plus bonus."', '"I know rates are kinda high right now."', '"What documents did I ask them for?"', '"We\'re ready to move forward this month."'];
export function QuoteMarquee() {
  const row = [...quotes, ...quotes];
  return <div className="group relative overflow-hidden border-y border-slate-200 bg-slate-50 py-3" aria-hidden="true" data-id="element-337">
      <span className="font-mono-brand absolute left-4 top-1/2 z-10 flex -translate-y-1/2 items-center gap-1.5 rounded border border-teal-600/25 bg-white px-2 py-0.5 text-[10px] font-bold tracking-widest text-teal-600/80" data-id="element-338">
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-teal-600/50" data-id="element-339" />
        REC
      </span>
      <div className="marquee-track flex w-max gap-10 pl-24 group-hover:[animation-play-state:paused]" data-id="element-340">
        {row.map((q, i) => <span key={i} className="font-mono-brand whitespace-nowrap text-xs italic text-slate-500" data-id="element-341">
            {q}
          </span>)}
      </div>
    </div>;
}